module.exports = __webpack_public_path__ + "img/advantage.d7e5e9b3.png";